/* eslint-disable arrow-body-style */
/* eslint-disable react/self-closing-comp */

import React from 'react';
import { InfiniteScrollLoadTrigger } from '@src/common/InfiniteScrollLoadTrigger/InfiniteScrollLoadTrigger';
import { riskScoresId } from '../../types';
import {
  riskScoresResultsApi,
  useRiskScoreResultsStore,
} from '../../mothership/riskScoresResults.state';

export const LoadTrigger = () => {
  const loading = useRiskScoreResultsStore((state) => state.loadingMore);
  const moreToLoad = useRiskScoreResultsStore((state) => state.moreToLoad);

  return (
    <React.Fragment>
      <InfiniteScrollLoadTrigger
        id={riskScoresId}
        loading={loading}
        moreToLoad={moreToLoad}
        setInfiniteScrollElement={riskScoresResultsApi.setInfiniteScrollElement}
      />
    </React.Fragment>
  );
};
